/**
 * Ministry icon badge.
 *
 * Renders one of the brand diamond icon artworks at a consistent size.
 */
export function IconDiamond({ src, alt = "" }: { src: string; alt?: string }) {
  return (
    <span className="inline-flex h-24 w-24 items-center justify-center">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-contain"
      />
    </span>
  );
}
